/** Mapper para asociar códigos de dirección de carretera con sus descripciones */
 export function mapDirectionCode(code: string | undefined | null): string {
  switch (code) {
    case 'N':
      return 'Creciente';
    case 'S':
      return 'Decreciente';
    case 'B':
      return 'Ambos sentidos';
    default:
      return '';
  }
}

export function mapDirectionCodeToText(code: string | undefined | null, roadStarPK: number, roadEndPk: number, roadStartingPoint: string, roadEndingPoint: string): string {

  //if(!roadStarPK || !roadEndPk || !roadStartingPoint || !roadEndingPoint) return '';

  let increasingRoadPks: boolean = roadStarPK < roadEndPk;

  let directionText: string | undefined;

  switch(code) {
    case "N":
      directionText = increasingRoadPks ? roadEndingPoint : roadStartingPoint;
      break;
    case "S":
      directionText = increasingRoadPks ? roadStartingPoint : roadEndingPoint;
      break;
    default:
      directionText = mapDirectionCode(code)
      break;
    }

  if(!directionText || directionText == undefined) return '';

  return directionText;
}

